import React from "react";
import { useQuery } from "react-query";

import { getAllCheapProperties } from "../utils/api";

const useCheapProperties = () => {
  const { data, isLoading, isError, refetch } = useQuery(
    "allPropertiesCheap",
    getAllCheapProperties,
    { refetchOnWindowFocus: false }
  );

  return {
    data,
    isError,
    isLoading,
    refetch,
  };
};

export default useCheapProperties;
